<template>
  <div class="flex items-center">
    <feather-icon icon="CircleIcon" :svgClasses="['fill-current h-4 w-4', textColor]" />
    <div class="ml-2">{{ params.value }}</div>
  </div>
</template>

<script>
export default {
  name: 'CellRendererEmail',
  computed: {
    textColor () {
      return this.params.data.isVerified ? 'text-primary' : 'text-grey'
    }
  }
}
</script>

<style scoped>

</style>
